import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    {...props}
  />
))(() => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: 8,
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
  }
}));

const Dropdown = ({ title, contents = [], onSelect, disabled }) => {
    const multiSelectTitles = ['Asset', 'Utility', 'Company']; 
    const isMultiSelect = multiSelectTitles.includes(title);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState(isMultiSelect ? [] : `Select ${title}`);
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (!isMultiSelect) {
      onSelect(selected);
    }
  }, [selected]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSingleSelect = (item) => {
    setSelected(item);
    onSelect(item);
    handleClose();
  };

  const handleMultiSelect = (item) => {
    let newSelected;
    if (item === 'Select All') {
      const allItems = contents.slice(); // clone array
      newSelected = selected.length === contents.length ? [] : allItems;
    } else {
      newSelected = selected.includes(item)
        ? selected.filter(i => i !== item)
        : [...selected, item];
    }

    setSelected(newSelected);
    onSelect(newSelected);
  };

  const displayLabel = isMultiSelect
    ? (selected.length ? selected.join(', ') : `Select ${title}`)
    : selected;

  return (
    <div>
      <Button
        variant="contained"
        disableElevation
        fullWidth
        disabled={disabled || contents.length === 0}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          backgroundColor: '#CCDAC5',
          borderColor: '#CCDAC5',
          color: 'rgb(55, 65, 81)',
          '&:hover': { backgroundColor: '#B8C9AE' },
        }}
      >
        {displayLabel}
      </Button>
      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {isMultiSelect && (
          <MenuItem onClick={() => handleMultiSelect('Select All')}>
            <Checkbox
              checked={selected.length === contents.length}
              indeterminate={selected.length > 0 && selected.length < contents.length}
            />
            <ListItemText primary="Select All" />
          </MenuItem>
        )}
        {contents.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => isMultiSelect ? handleMultiSelect(item) : handleSingleSelect(item)}
          >
            {isMultiSelect ? (
              <>
                <Checkbox checked={selected.includes(item)} />
                <ListItemText primary={item} />
              </>
            ) : item}
          </MenuItem>
        ))}
      </StyledMenu>
    </div>
  );
};

export default Dropdown;
